import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk'
import { appReducer } from '../core/reducers/appReducer';
import { authReducer } from '../core/reducers/authReducer';
import { currentReducer } from '../core/reducers/currentReducer';
import { graphicalReducer } from '../core/reducers/graphicalReducer';

const composeEnhancers: any = (typeof window !== 'undefined' && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const reducers = combineReducers({
    auth: authReducer,
    app: appReducer,
    ui: graphicalReducer,
    current: currentReducer
});

export const store = createStore(reducers,
    composeEnhancers(
        applyMiddleware(thunk)
    ));